export const FETCH_RESPONDER_ALERTS_CONFIGURATION_ERROR =
	'FETCH_RESPONDER_ALERTS_CONFIGURATION_ERROR' as const;

export const FETCH_SLACK_WORKSPACE_CONNECTIONS_ERROR =
	'FETCH_SLACK_WORKSPACE_CONNECTIONS_ERROR' as const;

export const REMOVE_SLACK_WORKSPACE_CONNECTIONS_ERROR =
	'REMOVE_SLACK_WORKSPACE_CONNECTIONS_ERROR' as const;

export const FETCH_CONFLUENCE_SPACE_CONFIGURATION_ERROR =
	'FETCH_CONFLUENCE_SPACE_CONFIGURATION_ERROR' as const;

export const FETCH_CONFLUENCE_SPACE_OPTIONS_ERROR = 'FETCH_CONFLUENCE_SPACE_OPTIONS_ERROR' as const;

export const FETCH_CONFLUENCE_PAGE_OPTIONS_ERROR = 'FETCH_CONFLUENCE_PAGE_OPTIONS_ERROR' as const;

export const SET_PIR_CONFIGURATIONS_ERROR = 'SET_PIR_CONFIGURATIONS_ERROR' as const;

export const FETCH_MSTEAMS_WORKSPACE_CONNECTIONS_ERROR =
	'FETCH_MSTEAMS_WORKSPACE_CONNECTIONS_ERROR' as const;

export const SET_MSTEAMS_WORKSPACE_CONNECTIONS_STATE_ERROR =
	'SET_MSTEAMS_WORKSPACE_CONNECTIONS_STATE_ERROR' as const;

export const FETCH_ZOOM_WORKSPACE_CONNECTIONS_ERROR =
	'FETCH_ZOOM_WORKSPACE_CONNECTIONS_ERROR' as const;

export const SET_ZOOM_WORKSPACE_CONNECTIONS_STATE_ERROR =
	'SET_ZOOM_WORKSPACE_CONNECTIONS_STATE_ERROR' as const;
